module.exports = __webpack_public_path__ + "static/media/shu_kai_hsieh.47fe0c97.png";